
class PopWindowManager {
    popWindowArr = [];
    popNum = 0;

    constructor() {

    }

    openNext(){
        let hallUI = cc.find("Canvas/gameNode").getComponent("HallUI");
        if (this.popWindowArr.length > this.popNum ){
            let pfb = hallUI.openChildUI(this.popWindowArr[this.popNum].pfb);
            pfb["popData"] = this.popWindowArr[this.popNum].data;
            this.popNum ++;
        }
    }

}
export default new PopWindowManager();
